import moment from "moment";
import { COMMUNITY_SUBSCRIPTION_PAGE_ROUTE } from "../../_pages/community-settings/community-subscription.page";

/**
 * @param {Object} community - The community to display the nudge for.
 * @description Displays a nudge to the user if community trial is about to over within 15 days.
 */
export default function CommunityUpgradeNudge({ community }) {
  if (!community || community.myRole !== "admin") {
    return null;
  }

  const createdAt = moment().diff(moment(community.createdAt), "days");

  const planExpiredIn = moment(community.planExpiryDate).diff(moment(), "days");

  if (isNaN(planExpiredIn) || planExpiredIn > 15 || createdAt > 15) {
    return null;
  }
  return (
    <div
      className="fixed bottom-0 left-0 right-0 p-4 theme-bg-surface font-semibold text-center border theme-border-default h-16 sm:h-12 shadow-inner"
      style={{ zIndex: 200 }}>
      <span>
        You are on a free Trail period for Start Plan. {planExpiredIn} days left
        in trial.
      </span>
      <span
        className="theme-text-primary cursor-pointer"
        onClick={() => {
          window.location.href = COMMUNITY_SUBSCRIPTION_PAGE_ROUTE;
        }}>
        {" "}
        Upgrade the plan{" "}
      </span>
      or{" "}
      <span className="">
        <a
          href="https://calendly.com/anil-pensil/pensil-demo"
          className="theme-text-primary cursor-pointer">
          Schedule a demo
        </a>
      </span>
    </div>
  );
}
